/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weary_Tame_Kudu_FetchInputs */

const fr_weary_tame_kudu_fetch = /** @type {(inputs: Weary_Tame_Kudu_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci pour votre paiement`)
};

/**

* @param {Weary_Tame_Kudu_FetchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weary_tame_kudu_fetch = /** @type {((inputs?: Weary_Tame_Kudu_FetchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weary_Tame_Kudu_FetchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weary_tame_kudu_fetch(inputs)
});